/**
 * 订阅本地历史记录
 * 
 * @Author: Focci
 * @Date: 2023-11-30 10:38:26
 * @Last Modified by: Focci
 * @Last Modified time: 2023-11-30 10:38:26
 */

'use client'

import PropTypes from 'prop-types'
import useMessage from '@hook/useMessage'
import useLogin from '@hook/useLogin'
import { ButtonBase, CircularProgress } from '@comp/material'
import SVGAddSubcribe from '@img/add-subcribe.svg'
import SVGAddedSubcribe from '@img/added-subcribe.svg'
import { useCallback, useState } from 'react'
import { fetchPost, fetchProxy } from '@lib/fetch/client'
import { useTranslations } from 'use-intl'

export default function HistoryClaimIcon({
  onUpdateSubcribe,
  subcribe,
  data,
  name,
}) {
  const ts = useTranslations('search')
  const { message } = useMessage()
  const { isLogin, openSigninDialog } = useLogin()
  const [loading, setLoading] = useState(false)
  
  const handleSubcribe = useCallback(() => {
    if(!isLogin) {
      return openSigninDialog()
    }

    const param = {
      ...data.param,
      emailAlert: '1',
      name,
    }
    
    return fetchProxy(
      fetchPost('user/criteria', param),
      setLoading
    )
      .then(() => {
        message(ts('subcribeSuccessfully'))
        onUpdateSubcribe(true)
      })
      .catch((err) => message(err.message))
  }, [data, message, name, onUpdateSubcribe, ts, isLogin, openSigninDialog])

  if(subcribe) {
    return <SVGAddedSubcribe className="opacity-50" />
  }

  return (
    <ButtonBase onClick={handleSubcribe} aria-label="Claim">
      {loading ? <CircularProgress size={20} /> : <SVGAddSubcribe />}
    </ButtonBase>
  )
}

HistoryClaimIcon.propTypes = {
  onUpdateSubcribe: PropTypes.func,
  subcribe: PropTypes.bool,
  data: PropTypes.object,
  name: PropTypes.string,
}
